// Cell header — leverage label + occupancy. PLAN.md §7.3, §2.3.

import { useMemo } from 'react'
import { CELL_SPECS, type CellNonSpectator } from '@trading-grounds/shared'
import { useStore } from '../../store.js'

const SPEC_BY_CELL = new Map(CELL_SPECS.map((s) => [s.cell, s]))

const BORDER_THICKNESS: Record<number, string> = {
  10: 'border-t border-black/30',
  5: 'border-t-[1.5px] border-black/40',
  2: 'border-t-2 border-black/55',
}

export function CellHeader({ cell }: { cell: CellNonSpectator }) {
  const players = useStore((s) => s.players)
  const tombstones = useStore((s) => s.tombstones)

  const occupancy = useMemo(() => {
    let occ = 0
    let rekt = 0
    for (const p of players.values()) {
      if (p.cell === cell) occ++
    }
    for (const t of tombstones) {
      if (t.cell === cell) rekt++
    }
    return { occ, rekt }
  }, [players, tombstones, cell])

  const spec = SPEC_BY_CELL.get(cell)
  if (!spec) return null

  const borderClass = BORDER_THICKNESS[spec.display_lev] ?? BORDER_THICKNESS[10]

  return (
    <div className={`flex items-center justify-between pt-1 pb-1.5 ${borderClass}`}>
      <span className="text-label text-black uppercase tracking-wider">
        {spec.display_lev}x {spec.direction}
      </span>
      <span className="text-label text-grey tabular-nums">
        {occupancy.occ} in{occupancy.rekt > 0 && ` · ${occupancy.rekt} rekt`}
      </span>
    </div>
  )
}
